module.exports = __webpack_public_path__ + "static/img/10.0bed5666.png";